export default class QuestionService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(question, options) {
    const response = await fetch(`${this.baseUri}/learning/question`, {
      body: JSON.stringify(question),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/question/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/learning/question`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, question, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${id}`, {
      body: JSON.stringify(question),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }


  async createAnswer(questionId, answer, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${questionId}/answer`, {
      body: JSON.stringify(answer),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async deleteAnswer(questionId, id, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${questionId}/answer/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async findAnswer(questionId, id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/question/${questionId}/answer/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAllAnswers(questionId, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${questionId}/answer`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async updateAnswer(questionId, id, answer, options) {
    const response = await fetch(`${this.baseUri}/learning/question/${questionId}/answer/${id}`, {
      body: JSON.stringify(answer),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}